import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Hero from "./components/Hero";
import Benefits from "./components/Benefits";
import ShowDetails from "./components/ShowDetails";
import ShowHighlights from "./components/ShowHighlights";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import BookingModal from "./components/BookingModal";
import AdminPanel from "./components/AdminPanel";
import AdminLogin from "./components/AdminLogin";
import AuthCallback from "./components/AuthCallback";
import { Toaster } from "./components/ui/sonner";

function LandingPage({ onBookingClick }) {
  return (
    <>
      <Hero onBookingClick={onBookingClick} />
      <ShowDetails />
      <Benefits onBookingClick={onBookingClick} />
      <Gallery />
      <ShowHighlights />
      <Testimonials onBookingClick={onBookingClick} />
      <FAQ />
      <Contact />
    </>
  );
}

// Router component that handles OAuth callback detection
function AppRouter({ isBookingModalOpen, setIsBookingModalOpen }) {
  const location = useLocation();
  
  // CRITICAL: Check for session_id in URL hash BEFORE rendering routes
  // This prevents race conditions with auth checking
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Routes>
        <Route 
          path="/" 
          element={<LandingPage onBookingClick={() => setIsBookingModalOpen(true)} />} 
        />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin/login" element={<AdminLogin />} />
      </Routes>
      <BookingModal
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
      />
    </>
  );
}

function App() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  return (
    <Router>
      <div className="App">
        <AppRouter 
          isBookingModalOpen={isBookingModalOpen}
          setIsBookingModalOpen={setIsBookingModalOpen}
        />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
